export function setCurrentTheme(theme) {
  return {
    type: 'SET_CURRENT_THEME',
    payload: {
      theme: theme
    }
  };
}
export function setDefaultTheme(theme) {
  return {
    type: 'SET_DEFAULT_THEME',
    payload: {
      theme: theme
    }
  };
}
export function setAllowThemeChange(allowChange) {
  return {
    type: 'SET_ALLOW_THEME_CHANGE',
    payload: {
      allowChange: allowChange
    }
  };
}